var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPortfolioManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37916 67.7417V14.7583H3.71249V67.6958C3.71249 70.7208 6.18749 73.1958 9.21249 73.1958L84.2875 73.0125V69.3458L9.21249 69.5292C8.20416 69.575 7.37916 68.75 7.37916 67.7417ZM82.4542 14.7583H70.6292V18.425H78.0083L50.05 46.3833L40.5625 36.8958C39.8292 36.1625 38.6833 36.1625 37.95 36.8958L12.375 62.5167L14.9875 65.1292L39.2792 40.8375L48.7667 50.325C49.5 51.0583 50.6458 51.0583 51.3792 50.325L80.6667 21.0375V28.4167H84.3333V16.5917C84.2875 15.5833 83.4625 14.7583 82.4542 14.7583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPortfolioManagement);
export default __webpack_public_path__ + "static/media/landing-portfolio-management.3273198e154b71a21e5a726c5292ab8a.svg";
export { ForwardRef as ReactComponent };